import * as d3 from 'd3';
import roundNumber from './roundNumber';
import { isSchoolSmall, smallThreshold } from './isSmallProjectedNode';

function getYDomain(data, activeSchool = null) {
  // We could directly return the limit we calculated, however this might (depending on the calculation)
  // leave a lot of empty space at the top of the graph, so, provided the point is within this limit, we calculate
  // the extents (relatively) normally.
  let max = 35;
  let min = -10;
  data.forEach(school => {
    const yearExtents = d3.extent(school.projections_percentage);
    if(isSchoolSmall(school)) {
      yearExtents[1] = Math.max(
        school.projections_percentage[0],
        school.projections_percentage[1],
      )
    }
    if (yearExtents[1] > max) {
      // If we're not limiting our extents or if we're under the threshold
      max = yearExtents[1];
    }
    if (yearExtents[0] < min) {
      min = yearExtents[0];
    }
  });

  // Default: take the max of the active school and then add 20% padding,
  // so we have breathing room for the node labels
  if (activeSchool) {
    const activeMax = d3.max(activeSchool.projections_percentage);
    let maxThreshold = activeMax * 1.2;
    if (max < maxThreshold) {
      max = maxThreshold;
    }
  } else {
    max *= 1.2;
    min *= 1.2;
  }
  // We round up/down to 10 because it'll mean the axis ticks look nice
  // and there's a full-increment tick at the start/end of the y axis
  return [roundNumber.downTo10(min), roundNumber.upTo10(max)];
}

export default getYDomain;



// WEBPACK FOOTER //
// ./src/components/singleClusterProjectionsLineGraph/getYDomain.js